
(function () {
    'use strict';
    angular
            .module('caloappApp')
            .factory('CaloriesService', CaloriesService);
    CaloriesService.$inject = ['$resource'];
    function CaloriesService($resource) {


        var service = $resource('api/meal-information/:idMealInformation', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    userLogin: null,
                    fromDate: null,
                    toDate: null,
                    fromTime: null,
                    toTime: null
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
        return service;
    }
}
)();
